<p-dialog [(visible)]="!licensed" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'idcard']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">Licensing</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<div class="d-flex w-100">
		<div class="text-center display-12">Please select an available license</div>
	</div>
	<span class="p-float-label mt-4">
		<p-dropdown
			#licenseSelectInput
			[options]="availableLicenses"
			optionLabel="name"
			optionValue="key"
			name="licenseSelectInput"
			[(ngModel)]="licenseKey"
			[style]="{ width: '100%' }"
			appendTo="body"
			[autoDisplayFirst]="false"
			[virtualScroll]="true"
			itemSize="30"
			filter="true"
			(filterBy)="app.keys(availableLicenses)"
		></p-dropdown>
		<label for="licenseSelectInput">Licenses</label>
	</span>
	<span class="p-float-label mt-4">
		<input pInputText #kioskDeviceName name="kioskDeviceName" type="text" [(ngModel)]="licenseName" class="w-100" />
		<label for="kioskDeviceName">Name</label>
	</span>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideAdd]="true"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]=""
			(onSaveChange)="licenseClaim(licenseKey)"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]=""
		></app-record-control-footer>
	</ng-template>
</p-dialog>
